import types from "rdx/modules/activateAcctBtnClicked/types";
import createAction from "rdx/utils/createAction";

export default {
  updateActivateAcctBtnClicked: (payload) => createAction(types.UPDATE_ACTIVATE_ACCT_BTN_CLICKED, payload),
  resetActivateAcctBtnClicked: (payload) => createAction(types.RESET_ACTIVATE_ACCT_BTN_CLICKED, payload),
};
